// Generate unique IDs
const generateId = (prefix) => `${prefix}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

// Create a new block with default values
export const createBlock = (type) => {
  const baseBlock = {
    id: generateId("block"),
    type,
  };

  switch (type) {
    case "text":
      return {
        ...baseBlock,
        content: "Click to edit this text. You can use merge tags like {{first_name}} to personalize your emails.",
        fontSize: "16px",
        textColor: "#1f2937",
        textAlign: "left",
        lineHeight: "1.6",
        fontWeight: "normal",
      };

    case "image":
      return {
        ...baseBlock,
        src: "",
        alt: "",
        width: "100%",
        alignment: "center",
        borderRadius: "0",
      };

    case "button":
      return {
        ...baseBlock,
        text: "Learn More",
        href: "#",
        backgroundColor: "#1CBCF8",
        textColor: "#ffffff",
        alignment: "center",
        borderRadius: "6px",
        buttonPadding: "12px 24px",
        fontSize: "14px",
        fontWeight: "600",
      };

    case "divider":
      return {
        ...baseBlock,
        style: "solid",
        thickness: "1px",
        color: "#e5e7eb",
        padding: "10px 0",
      };

    case "spacer":
      return {
        ...baseBlock,
        height: "20px",
      };

    case "social":
      return {
        ...baseBlock,
        socials: [
          { type: "facebook", url: "" },
          { type: "twitter", url: "" },
          { type: "linkedin", url: "" },
        ],
        alignment: "center",
        iconSize: "32px",
        iconStyle: "circle",
        iconBackground: "#1CBCF8",
        iconColor: "#ffffff",
        spacing: "12px",
      };

    case "columns":
      return {
        ...baseBlock,
        columns: 2,
        gap: "20px",
        columnContent: [
          { content: "Column 1 content" },
          { content: "Column 2 content" },
        ],
        columnBackground: "transparent",
      };

    case "list":
      return {
        ...baseBlock,
        listType: "bullet",
        items: ["First item", "Second item", "Third item"],
        textColor: "#1f2937",
        fontSize: "16px",
        lineHeight: "1.8",
      };

    case "html":
      return {
        ...baseBlock,
        html: "<p>Custom HTML content</p>",
      };

    default:
      return baseBlock;
  }
};

// Create a default template structure
export const createDefaultTemplate = () => [
  // Header Section
  {
    id: generateId("section"),
    type: "header",
    backgroundColor: "#1CBCF8",
    padding: "30px 20px",
    blocks: [
      {
        id: generateId("block"),
        type: "text",
        content: "OMNΛS",
        fontSize: "28px",
        textColor: "#ffffff",
        textAlign: "center",
        fontWeight: "bold",
      },
      {
        id: generateId("block"),
        type: "text",
        content: "Construction Intelligence",
        fontSize: "14px",
        textColor: "rgba(255,255,255,0.9)",
        textAlign: "center",
        fontWeight: "normal",
      },
    ],
  },
  // Content Section
  {
    id: generateId("section"),
    type: "content",
    backgroundColor: "#ffffff",
    padding: "30px 20px",
    blocks: [
      {
        id: generateId("block"),
        type: "text",
        content: "Hello {{first_name}},",
        fontSize: "24px",
        textColor: "#1f2937",
        textAlign: "left",
        fontWeight: "bold",
      },
      {
        id: generateId("block"),
        type: "text",
        content: "We have exciting updates to share with you this month. Click below to learn more about the latest opportunities and features.",
        fontSize: "16px",
        textColor: "#4b5563",
        textAlign: "left",
        lineHeight: "1.6",
      },
      {
        id: generateId("block"),
        type: "button",
        text: "View Updates",
        href: "#",
        backgroundColor: "#1CBCF8",
        textColor: "#ffffff",
        alignment: "center",
        borderRadius: "6px",
      },
    ],
  },
  // Footer Section
  {
    id: generateId("section"),
    type: "footer",
    backgroundColor: "#f9fafb",
    padding: "20px",
    blocks: [
      {
        id: generateId("block"),
        type: "social",
        socials: [
          { type: "facebook", url: "#" },
          { type: "twitter", url: "#" },
          { type: "linkedin", url: "#" },
        ],
        alignment: "center",
        iconSize: "28px",
        iconStyle: "circle",
        iconBackground: "#1CBCF8",
      },
      {
        id: generateId("block"),
        type: "text",
        content: "© 2026 OMNΛS by Pantheon Technologies<br/>You received this email because you're subscribed to our newsletter.",
        fontSize: "12px",
        textColor: "#9ca3af",
        textAlign: "center",
      },
    ],
  },
];

// Create a blank template
export const createBlankTemplate = () => [
  {
    id: generateId("section"),
    type: "content",
    backgroundColor: "#ffffff",
    padding: "20px",
    blocks: [],
  },
];
